/* eslint-disable import/no-extraneous-dependencies */
import printJS from 'print-js';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.provide(printJS);
});
